/**
 * To avoid breaking UW on IE11, we lazy load @cld/metadata-form
 * since it creates a dependency chain to @formatjs which uses polyfills that break in IE -
 * We only (lazy) load @cld/metadata-form if we're not in IE
 */
import { isIE } from "react-device-detect";

let getPreparedMetadataValues = null;
let SMD_DISPLAY_FORMAT;

const isMetadataSupported = !isIE;

if (isMetadataSupported) {
	import("@cld/metadata-form")
		.then((mdForm) => {
			getPreparedMetadataValues = mdForm.getPreparedMetadataValues;
			SMD_DISPLAY_FORMAT = mdForm.SMD_DISPLAY_FORMAT;
		});
}

const getIsStructuredMetadataSupported = () => isMetadataSupported;

export {
	getIsStructuredMetadataSupported,
	getPreparedMetadataValues,
	SMD_DISPLAY_FORMAT
};
